export const DRProjectHeaderDef = (data, projectIndex,scenarioProjectExist) => {
  if (data.length !== 0) {
    let projects = [];
    projects = data.scenario_project_asset ?
      projects.concat([data.scenario_project_asset, ...data.scenario_project_contracts, data.scenario_project_epc])
      :projects.concat([data.user_project_asset, ...data.user_project_contracts, data.user_project_epc]);
    projects = projects.map((project, i) => {
      const result = {
        headerName: project.name,
        children: (i === 0 && [{
          headerName: 'name',
          field: 'pname',
          cellRenderer: "agGroupCellRenderer",
          editable: false,
          width: 250,
          projectIndex,
          textAlign: 'left'
        }]) || [],
      };
      const keys = Object.keys(project.data);
      const values = Object.values(project.data);
      keys.map((key, ind) => {
        if (values[ind].type === 'object') {
          const choices = values[ind].choices.map((choice) => {
            return {name: choice.name, key: choice.key}
          });
          result.children.push({
            headerName: key,
            field: key + i,
            width: 150,
            cellEditorSelector: (params) => {
              if (params.data.pname === "Tied Document?") {
                return {component: 'checkboxAgGridEditor'};
              } else if (params.data.inputType) {
                return {component: 'selectAgGridEditor', params: {values: choices}}
              }
              return null
            },
            cellRendererSelector: (params) => {
              if (params.data.inputType) {
                return {component: 'selectAgGridRenderer', params: {values: choices}}
              }
              return null
            },
          })
        } else if (values[ind].type === 'boolean') {
          result.children.push({
            headerName: key,
            field: key + i,
            width: 150,
            cellEditorSelector: (params) => {
              if (params.data.inputType || params.data.pname === "Tied Document?") {
                return {component: 'checkboxAgGridEditor'}
              }
              return null
            },
          })
        } else {
          result.children.push({
            headerName: key,
            field: key + i,
            width: 150,
            cellEditorSelector: (params) => {
              if (params.data.pname === "Tied Document?") {
                return {component: 'checkboxAgGridEditor'};
              } else if (params.data.inputType) {
                return {
                  component: 'simpleInputAgGridEditor',
                  params: {type: values[ind].type, required: project.required.includes(key) ? key : ''}
                };
              }
              return null;
            },
            cellRendererSelector: (params) => {
              if (params.data.inputType) {
                return {component: 'simpleInputAgGridRenderer'};
              }
            }
          })
        }

      });
      return result;
    });
    projects.unshift({
      headerName: 'Schema Object',
      children: [{
        headerName: 'Parameter/Input Type',
        field: 'inputType',
        width: scenarioProjectExist ? 250: 150,
        editable: false,
        projectData: data,


        cellRendererSelector: (params) => {
          if (params.value && !scenarioProjectExist) {
            return {
              component: 'customIcons',
              params: {id: params.data.projectId, assetSchemaId: params.data.assetSchemaId}
            };
          }
          return null
        },
      }]
    });
    return projects;
  }
  return [];
};

export const DRProjectRowDef = (data, projectIndex) => {
  return data.map((d) => {
    const arrayOfObj = d.scenario_project_asset ?
      [d.scenario_project_asset, ...d.scenario_project_contracts, d.scenario_project_epc]
      :[d.user_project_asset, ...d.user_project_contracts, d.user_project_epc];
    let objectOfResult = {
      projectId: d.previous_id ? d.previous_id : d.id,
      projectIndex: projectIndex,
      inputType: 'Project ' + d.name + ' data',
      pname: 'Project ' + d.name,
      participants: [
        {inputType: '', pname: 'Source'},
        {inputType: '', pname: 'Tied Document?'},
        {inputType: '', pname: 'Verifier'}
      ]
    };
    arrayOfObj.map((obj, i) => {
      const keys = Object.keys(obj.data);
      const addFieldKeys = Object.keys(obj.additional_fields);
      const values = Object.values(obj.data);
      const addFieldsValues = Object.values(obj.additional_fields);

      keys.map((key, ind) => {
        objectOfResult[key + i] = values[ind].value;
        objectOfResult.participants[0][addFieldKeys[ind] + i] = addFieldsValues[ind].source.value;
        objectOfResult.participants[1][addFieldKeys[ind] + i] = addFieldsValues[ind].tied_document.value;
        objectOfResult.participants[2][addFieldKeys[ind] + i] = addFieldsValues[ind].verifier.value;

      })
    });
    return objectOfResult;
  });
};

export const DRProjectPreEditingFiltering = (data, prevProject) => {

  const projectValues = Object.values(data);
  const {user_project_asset, user_project_contracts, user_project_epc} = prevProject;
  let count = 5;

  const result = {
    name: data.pname.slice(8, data.pname.length),
    user_project_asset: {
      data: {},
      additional_fields: {},
      asset_schema_id: prevProject.user_project_asset.asset_schema_id,
    },
    user_project_contracts: [],
    user_project_epc: {
      data: {},
      additional_fields: {},
      epc_schema_id: prevProject.user_project_epc.epc_schema_id,
    },
    // user_project: prevProject.id
  };

  // assets data set start
  const assetData = user_project_asset.data;

  Object.keys(assetData).map((key, i) => {
    if (assetData[key].type === 'integer' || assetData[key].type === 'number') {
      result.user_project_asset.data[key] = +projectValues[i + count];
    } else if (assetData[key].type === 'string') {
      result.user_project_asset.data[key] = projectValues[i + count] + '';
    } else if (assetData[key].type === 'object') {
      result.user_project_asset.data[key] = projectValues[i + count];

    }
    result.user_project_asset.additional_fields[key] = {
      source: projectValues[5][0] && key !== 'pname' && projectValues[5][0][key + 0] || '',
      verifier: projectValues[5][2] && key !== 'pname' && projectValues[5][2][key + 0] || '',
      tied_document: Boolean(projectValues[5][1] && key !== 'pname' && projectValues[5][1][key + 0])
    }
  });
  // assets data set end

  count += Object.keys(user_project_asset.data).length;

  // contracts data set start
  result.user_project_contracts = user_project_contracts.length > 0
    && user_project_contracts.map((contract, i) => {
      const contractObj = {
        data: {},
        additional_fields: {},
        contract_schema_id: contract.contract_schema_id,
      };
      Object.keys(contract.data).map((key) => {
        if (contract.data[key].type === 'integer' || contract.data[key].type === 'number') {
          contractObj.data[key] = +projectValues[count];
        } else if (contract.data[key].type === 'boolean') {
          contractObj.data[key] = Boolean(projectValues[count]);
        } else if (contract.data[key].type === 'string') {
          contractObj.data[key] = projectValues[count] + '';
        }
        contractObj.additional_fields[key] = {
          source: projectValues[5][0] && projectValues[5][0][key + (1 + i)] || '',
          verifier: projectValues[5][2] && projectValues[5][2][key + (1 + i)] || '',
          tied_document: Boolean(projectValues[5][1] && projectValues[5][1][key + (1 + i)])
        };
        count += 1;
      });
      return contractObj;
    }) || [];
  // contracts data set end

  const length = user_project_contracts.length;

  // epc data set start
  const epcData = user_project_epc.data;
  Object.keys(epcData).map((key, i) => {

    if (epcData[key].type === 'boolean') {
      result.user_project_epc.data[key] = Boolean(projectValues[count + i]);
    } else if (epcData[key].type === 'integer' || epcData[key].type === 'number') {
      result.user_project_epc.data[key] = +projectValues[count + i];
    } else if (epcData[key].hasOwnProperty('list')) {
      result.user_project_epc.data[key] = projectValues[count + i];
      // valueSplit(projectValues[4][0][count + i]);
    } else {
      result.user_project_epc.data[key] = projectValues[count + i];
    }

    result.user_project_epc.additional_fields[key] = {
      source: projectValues[5][0] && projectValues[5][0][key + (1 + length)] || '',
      verifier: projectValues[5][2] && projectValues[5][2][key + (1 + length)] || '',
      tied_document: Boolean(projectValues[5][1] && projectValues[5][1][key + (1 + length)])
    };


  });
  // epc data set end

  return result;
};


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomProject/helpers.js